import React, { Component } from 'react';
import MainRowSection from './MainRowSection';
import KpisSection from './KpisSection';
import FiltersSection from './FiltersSection';
import TableConfSection from './TableConfSection';

export default class pageHead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      showFilter: false,
    };
  }
  render() {
    return (
      <div className='pageHead'>
        <MainRowSection />
        <div className='pageHead-kpis wrapper' >
          <KpisSection />
        </div>
        <FiltersSection />

        <TableConfSection />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FichaLogistica/Asignaciones/PageHead.js